/**
 * Chat: a Discord-style messaging space — 1:1 DMs, group DMs, and owned
 * channels, plus sharing Board/Collection/Document references. Like Documents
 * and Task Manager it is HOST-RENDERED (ChatSidebar.js + ChatMessageView.js)
 * rather than sandboxed: chat needs live Phoenix sockets + shared auth/presence
 * stores, which the guest iframe CSP (`connect-src 'none'`) forbids. The guest
 * entry.js is a no-op kept only to satisfy the registration contract.
 *
 * The icon-rail slot sits right after Documents; clicking it opens the chat
 * panel (App.js `activeTab === 'chat.panel'` branch → ChatSidebar as the
 * sidebar, ChatMessageView as the content).
 */
export const chatManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.chat',
  name: 'Chat',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'message-square',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: the panel above is a first-party React
  // component calling Tauri directly, so `permissions: []` means "declares no
  // GUEST capabilities", not "has no access". Settings reads this flag to say
  // that plainly instead of showing an empty permission list that implies a
  // control the user does not have — see EXT-05.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      { id: 'chat.activity', title: 'Chat', icon: 'message-square', order: { after: 'documents.activity' } },
    ],
    panels: [{ id: 'chat.panel', activityBarId: 'chat.activity', title: 'Chat' }],
    settings: [],
  },
};
